import React, { useEffect, useState } from "react";

const Countdown = ({ target }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);
  const pad = (n) => String(n).padStart(2, "0");

  const units = [
    { label: "Jours", value: pad(d) },
    { label: "Heures", value: pad(h) },
    { label: "Minutes", value: pad(m) },
    { label: "Secondes", value: pad(s) },
  ];

  return (
    <div data-testid="countdown-timer" className="flex items-center justify-center gap-6 md:gap-14">
      {units.map((u, i) => (
        <div key={u.label} className="flex items-center gap-6 md:gap-14">
          <div className="flex flex-col items-center">
            <span className="font-serif text-4xl md:text-6xl text-[color:var(--gold)] tabular-nums leading-none">{u.value}</span>
            <span className="label-caps text-white/50 mt-3 text-[10px]">{u.label}</span>
          </div>
          {i < units.length - 1 && <span className="font-serif text-3xl md:text-5xl text-white/20 leading-none">:</span>}
        </div>
      ))}
    </div>
  );
};

export default Countdown;
